import { z } from 'zod';
import { parseCanonicalRoleKey } from './headcount';
export const HiringRateCardSchema = z.object({
    fiscal_year: z.number().int().min(2020).max(2100),
    loading_multiplier: z.number().min(1).max(3),
    salaries: z
        .record(z.string(), z.number().nonnegative())
        .superRefine((salaries, ctx) => {
        for (const key of Object.keys(salaries)) {
            if (!parseCanonicalRoleKey(key)) {
                ctx.addIssue({
                    code: 'custom',
                    message: `Salary key is not a canonical "Division|Department|Grade" role key: ${key}`,
                });
            }
        }
    }),
    seeded_from: z.string().nullable(),
    created_at: z.string(),
    created_by: z.string().min(1),
    updated_at: z.string(),
    updated_by: z.string().min(1),
});
/**
 * Loaded monthly planning cost for one role: annual salary x loading
 * multiplier, spread over 12 months.
 */
export function loadedMonthlyCost(annualSalary, loadingMultiplier) {
    return (annualSalary * loadingMultiplier) / 12;
}
/**
 * Dec-Nov fiscal year a calendar month belongs to (D6): December rolls into
 * the following fiscal year, so "2025-12-01" is FY2026.
 */
export function fiscalYearOfMonth(month) {
    const [year, monthNumber] = month.split('-').map(Number);
    return monthNumber === 12 ? year + 1 : year;
}
